var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 341,
    fill: "none",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillOpacity: 0.3,
    d: "M0-111h1200v397s-252.211 51.289-538.449 54C375.312 342.711 0 292 0 292v-403Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1-114h1199v378s-252 51.289-538 54C376 320.711 0 270 0 270v-384Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 60h1200v188s-327 63.289-613 66C301 316.711 0 273 0 273V60Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 60h1200v188s-327 63.289-613 66C301 316.711 0 273 0 273V60Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 1201,
    height: 255,
    x: -1,
    y: 60,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF1F6",
    d: "M0 60h1200v188s-327 63.289-613 66C301 316.711 0 273 0 273V60Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 1438,
    height: 328,
    x: -124,
    y: -13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M-123.5 258.5-109-13h1395l27.5 245c-232.5 34.5-487.705 80.384-725.581 83-237.486-2.721-265.419-4-711.419-56.5Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C7",
    fillOpacity: 0.05,
    d: "M774.502 1161.55c72.001-3.83 144.529-16.6 217.321-38.74C1514.56 964.017 1919.92 369.717 2099-392.74 1846.08 72.142 1341.28 313.096 774.502 323.314 207.726 312.671-296.808 72.141-549.998-392.74-370.919 369.717 34.449 964.017 557.181 1122.81c72.792 21.71 145.32 34.48 217.321 38.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2070E8",
    fillOpacity: 0.25,
    d: "M1243.34 184.225c102.44 30.548 204.48 74.055 305.68 131.036C2275.79 724.198 2778.24 1714.59 2935.35 2866.48 2634.05 2114.1 1943.59 1594 1134.58 1382.03 322.864 1199.88-429.69 1367.89-852 1944.02-497.039 916.86 159.636 208.787 927.603 163.907c106.887-5.677 212.247 1.329 315.737 20.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C7",
    fillOpacity: 0.05,
    d: "M1232.5 70.76c104.07 5.535 208.91 23.986 314.13 55.967C2302.21 356.131 2888.15 1214.7 3147 2316.21 2781.41 1644.6 2051.75 1296.5 1232.5 1281.74 413.251 1297.12-316.027 1644.6-682.001 2316.21-423.151 1214.7 162.788 356.131 918.372 126.727 1023.59 95.361 1128.43 76.91 1232.5 70.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154A99",
    fillOpacity: 0.29,
    d: "M421.155 420.269c113.733 46.994 226.413 108.503 337.53 185.053C1556.67 1154.75 2075.77 2329.98 2199.28 3644.03 1895.3 2761.18 1143.24 2091.29 243.733 1753.08c-903.919-305.05-1757.473-209.22-2258.663 386.12C-1568.66 1028.61-797.982 313.945 67.226 358.413c120.398 6.829 238.484 27.723 353.929 61.856Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 600,
    x2: 600,
    y1: -92,
    y2: 449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#007EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63D9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 600.5,
    x2: 600.5,
    y1: -114,
    y2: 427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#007EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63D9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 647,
    x2: 647,
    y1: 60,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#007EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#1561D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#00A0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 647,
    x2: 647,
    y1: 60,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#007EE5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 588.5,
    x2: 588.5,
    y1: -13,
    y2: 499.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#154A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63D9EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHero);
export default __webpack_public_path__ + "static/media/bg-hero.dbdbf0456b0ff05fb984c8fe548b297d.svg";
export { ForwardRef as ReactComponent };